import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import { Auth0Provider } from "@auth0/auth0-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Entry } from "./Entry";
import { Dashboard } from "@/routes/Dashboard";
import { Lessons } from "@/routes/Lessons";
import { Appointments } from "@/routes/Appointments";
import { UserProvider } from "@/lib/client/state/UserProvider";
import { LessonPage } from "@/routes/LessonPage";

const queryClient = new QueryClient();

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <BrowserRouter>
          <Auth0Provider
            domain="amosinstitute.auth0.com"
            clientId={"iqHCq3fzuFpuvNfpHipJET7nxjYFrhRM"}
            authorizationParams={{
              redirect_uri: window.location.origin,
            }}
          >
            <Routes>
              <Route path="/" element={<Entry />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/lessons" element={<Lessons />} />
              <Route
                path="/lessons/:program/:lesson"
                element={<LessonPage />}
              />
              <Route path="/appointments" element={<Appointments />} />
            </Routes>
          </Auth0Provider>
        </BrowserRouter>
      </UserProvider>
    </QueryClientProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
